import React from "react";
import { TStaticDrawFunction } from "../../../Components/Canvas";
import { MeasurementChartPainter } from "./MeasurementChartPainter";
import MeasurementChart from "./MeasurementChart";
import useControlAttribute from "../../../hooks/useControlAttribute";
import { IControl } from "../types";
import useControlMeasurements from "../../../hooks/useControlMeasurements";
import { useTranslation } from "react-i18next";

interface IComfoair350FanChartProps {
  control: IControl;
  width: number;
  height: number;
}

const Comfoair350FanChart = (props: IComfoair350FanChartProps) => {
  const { control, width, height } = props;
  const value = useControlAttribute(control, "fan");
  const { valuesList } = useControlMeasurements(control, ["fan"]);
  const { t } = useTranslation();

  if (!valuesList) {
    return null;
  }

  const draw: TStaticDrawFunction = (ctx) => {
    const chart = new MeasurementChartPainter(width, height);
    const colorList = ["#000000"];
    chart.drawLines(ctx, valuesList, colorList, "", [0, 3, 1]);
  };

  return (
    <MeasurementChart
      title={t("Fan Level") + ` ${value}`}
      draw={draw}
      width={width}
      height={height}
    />
  );
};

export default Comfoair350FanChart;
